export const antdProComponentsBuiltInAPI = [
  'CheckCard',
  'ProCard',
  'Statistic',
  'StatisticCard',
  'FieldRender',
  'ProDescriptions',
  'FieldCode',
  'FieldDatePicker',
  'FieldIndexColumn',
  'FieldMoney',
  'FieldPercent',
  'FieldProgress',
  'FieldRangePicker',
  'FieldSelect',
  'FieldStatus',
  'FieldText',
  'FieldTimePicker',
  'ProField',
  'FieldContext',
  'FormListContext',
  'GridContext',
  'ProForm',
  'ProFormContext',
  'DrawerForm',
  'LightFilter',
  'LoginForm',
  'LoginFormPage',
  'ModalForm',
  'ProFormGroup',
  'QueryFilter',
  'StepsForm',
  'BetaSchemaForm',
  'FormControlRender',
  'FormItemProvide',
  'FormItemRender',
  'Group',
  'ProFormCaptcha',
  'ProFormCascader',
  'ProFormCheckbox',
  'ProFormColorPicker',
  'ProFormDateMonthRangePicker',
  'ProFormDatePicker',
  'ProFormDateQuarterRangePicker',
  'ProFormDateRangePicker',
  'ProFormDateTimePicker',
  'ProFormDateTimeRangePicker',
  'ProFormDateWeekRangePicker',
  'ProFormDateYearRangePicker',
  'ProFormDependency',
  'ProFormDigit',
  'ProFormDigitRange',
  'ProFormField',
  'ProFormFieldSet',
  'ProFormItem',
  'ProFormItemRender',
  'ProFormList',
  'ProFormMoney',
  'ProFormRadio',
  'ProFormRate',
  'ProFormSegmented',
  'ProFormSelect',
  'ProFormSlider',
  'ProFormSwitch',
  'ProFormText',
  'ProFormTextArea',
  'ProFormTimePicker',
  'ProFormTreeSelect',
  'ProFormUploadButton',
  'ProFormUploadDragger',
  'Submitter',
  'DefaultFooter',
  'DefaultHeader',
  'FooterToolbar',
  'GridContent',
  'PageContainer',
  'PageHeader',
  'PageLoading',
  'ProBreadcrumb',
  'ProLayout',
  'ProPageHeader',
  'RouteContext',
  'SettingDrawer',
  'TopNavHeader',
  'WaterMark',
  'ProHelp',
  'ProHelpProvide',
  'ProHelpSelect',
  'ProHelpContentPanel',
  'ProHelpDrawer',
  'ProHelpModal',
  'ProHelpPanel',
  'SelectKeyProvide',
  'ProHelpPopover',
  'RenderContentPanel',
  'BaseProList',
  'ProList',
  'ConfigConsumer',
  'ProConfigProvider',
  'ProProvider',
  'DescriptionsSkeleton',
  'ListPageSkeleton',
  'ListSkeleton',
  'ListSkeletonItem',
  'ListToolbarSkeleton',
  'PageHeaderSkeleton',
  'ProSkeleton',
  'TableItemSkeleton',
  'TableSkeleton',
  'CellEditorTable',
  'DragSortTable',
  'EditableProTable',
  'IndexColumn',
  'IntlConsumer',
  'ListToolBar',
  'ProTable',
  'RowEditorTable',
  'Search',
  'TableDropdown',
  'TableStatus',
  'DropdownFooter',
  'ErrorBoundary',
  'FieldLabel',
  'FilterDropdown',
  'InlineErrorFormItem',
  'LabelIconTip'
]
